import { render, staticRenderFns } from "./NewProposalModal.vue?vue&type=template&id=6faf7903"
import script from "./newProposalModal.ts?vue&type=script&lang=ts&external"
export * from "./newProposalModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports